import isNil from 'lodash/isNil'
import { create } from 'zustand'

interface SidebarState {
  isOpen: boolean
  toggle: (isOpen?: boolean) => void
  currentOpenedProduct: string | null
  toggleCurrentOpenedProduct: (product: string | null, isOpened?: boolean) => void
  searchInputFocusedId: string | null
  setSearchInputFocusedId: (id: string | null) => void
}

const useSidebarStore = create<SidebarState>(set => ({
  isOpen: false,
  searchInputFocusedId: null,
  setSearchInputFocusedId: (id: string | null) => {
    set(state => ({
      ...state,
      searchInputFocusedId: id,
    }))
  },
  toggle: (isOpen?: boolean) => {
    set(state => ({
      ...state,
      isOpen: isOpen ?? !state.isOpen,
    }))
  },
  currentOpenedProduct: null,
  toggleCurrentOpenedProduct: (product: string | null, isOpened?: boolean) => {
    set(s => {
      if (!isNil(isOpened)) {
        return {
          ...s,
          currentOpenedProduct: isOpened ? product : null,
        }
      }
      return {
        ...s,
        currentOpenedProduct: s.currentOpenedProduct === product ? null : product,
      }
    })
  },
}))

export default useSidebarStore
